import React from "react";
import { Link } from "react-router-dom";
import video from "./video.mp4";
import "./banner.css";

function Banner() {
  return ( 
    <div id="hero">
      <div className="overlay"></div>
      <video className="video" autoPlay loop muted playsInline>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="content">
        <p>Stop feeling overwhelmed with your property search!</p>
        <h5>Buyers Galaxy - Melbourne Buyers Agent</h5>
        <h3>
          We’re buying before the Melbourne market becomes <span>hotspot</span>!
        </h3>
        <Link to="/contact" className="con-btn">
          Consult Today
        </Link>
      </div>
    </div>
  );
}

export default Banner;
